export default __webpack_public_path__ + "locales/sr-Latn-RS/SharingPanel.json?hash=a0372d069ee820f0c44da7677f39e6a4";